import { LinearProgress} from '@mui/material';

export default LinearProgress;